/* global module require */

window.onerror = null;

const lib = {
    bugsnag: require('./bugsnag.ts'),
    logrocket: require('./logrocket.ts'),
    site_wide_banner: {
        init() {
            if (document.getElementById('js-site-wide-banner')) {
                import('../tv_site_wide_banner/site_wide_banner.ts').then(m => m.init());
            }
        }
    },
    ajax_toggle: require('../tv_utils/ajax_toggle.ts'),
    // The modules below are only fetched on pages with the elements they bind to.
    email_validation: {
        init() {
            if (document.querySelector('.js-tv-email-registration')) {
                import('../tv_address_book/email_validation.ts').then(m => m.init());
            }
        }
    },
    g_recaptcha: {
        init_g_recaptcha(recaptcha_element = null) {
            if (recaptcha_element || document.getElementsByClassName('g-recaptcha').length > 0) {
                import('../tv_third_party_integrations/g_recaptcha.ts')
                    .then(m => m.init_g_recaptcha(recaptcha_element));
            }
        }
    },
    password_view: {
        init_change_password() {
            if (document.getElementById('js-change-password-controls')) {
                import('../tv_utils/password_view.ts').then(m => m.init_change_password());
            }
        }
    },
    // Callers already check for the search results element.
    search: {
        init() {
            import('../tv_search/search.ts').then(m => m.init());
        }
    },
    search_bar: require('../tv_utils/search_bar.ts'),
    tv_modal: require('../tv_utils/tv_modal.ts'),
    modal_closer: require('../tv_utils/modal_closer.ts'),
    sign_in: require('../tv_utils/sign_in.ts'),
    site_navigation: require('../tv_utils/site_navigation.ts'),
    // Used by order details and the design service requests block, which can be placed on any page.
    customer_chat_log: {
        // A function, not a method, because callers use `new`.
        CustomerChatHandler: function() {
            import('../tv_utils/customer_chat_log.ts').then(m => new m.CustomerChatHandler());
        }
    },
    // Reseller sign up and the guest save password form on checkout complete.
    users: {
        init() {
            const ids = ['reseller_account', 'resale_verification', 'website_request', 'tv-guest-save-password'];
            if (ids.some(id => document.getElementById(id))) {
                import('../tv_users/users.ts').then(m => m.init());
            }
        }
    },
    // Site reviews, product reviews and the header badge. Our code waits for the third party Yotpo
    // script, which loads late, so fetching this on demand doesn't miss anything.
    yotpo: {
        init() {
            const selector = '#yotpo-testimonials-custom-tab, .tv-yotpo__reviews, .tv-header-badge .yotpo-badge';
            if (document.querySelector(selector)) {
                import('../tv_third_party_integrations/yotpo.ts').then(m => m.init());
            }
        }
    },
};

module.exports = lib;
